import { InjectionToken } from '@angular/core';
import * as Webauthn from '@simplewebauthn/browser';

export const WEBAUTHN_LIBRARY = new InjectionToken<WebauthnLibrary>('WebauthnLibrary');
export const getWebauthnLibrary = () => Webauthn;
export type WebauthnLibrary = typeof Webauthn;
